export var validateFileInput = (fileName, fileSize) => {
  var _a, _b;
  var MAX_SIZE_MB = 5;
  var ALLOWED_TYPES = ['jpeg', 'png', 'jpg'];
  var fileType = (_b = (_a = fileName === null || fileName === void 0 ? void 0 : fileName.split('.')) === null || _a === void 0 ? void 0 : _a.pop()) === null || _b === void 0 ? void 0 : _b.toLowerCase();
  var isSizeValid = fileSize <= MAX_SIZE_MB * 1024 * 1024;
  var isTypeValid = ALLOWED_TYPES.includes(fileType);
  return {
    isSizeValid,
    isTypeValid
  };
};
export var getIsDisabledState = (disabledState, widgetInternalDisabledState) => {
  return disabledState || widgetInternalDisabledState;
};
export var getFileSubtitle = fileInfo => {
  var fileName = fileInfo.fileName,
    fileSize = fileInfo.fileSize;
  var truncatedFilename = fileName.length > 20 ? (fileName === null || fileName === void 0 ? void 0 : fileName.substring(0, 20)) + '...' : fileName;
  var KB = 1024;
  var MB = 1024 * 1024;
  var formattedFilesize;
  if (fileSize < MB) {
    formattedFilesize = (fileSize / KB).toFixed(1) + ' KB';
  } else {
    formattedFilesize = (fileSize / MB).toFixed(1) + ' MB';
  }
  return truncatedFilename + " | " + formattedFilesize;
};
export var getUploadFileErrorText = fileInfo => {
  var _a;
  var errorText = '';
  if (fileInfo.error) {
    errorText = !((_a = fileInfo === null || fileInfo === void 0 ? void 0 : fileInfo.error) === null || _a === void 0 ? void 0 : _a.isTypeValid) ? 'Only JPEG, PNG, or JPG files are allowed.' : 'Upload a file smaller than 5 MB.';
  }
  return errorText;
};